import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import BackMethods from "../back_component/BackMethods";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState({});
  const [isScrolled, setIsScrolled] = useState(false);
  const { getUserConstraints } = BackMethods();
  const [isAdmin, setIsAdmin] = useState(getUserConstraints().isSuperAdmin);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // إغلاق القائمة تلقائياً عند تغيير المسار في الموبايل
  useEffect(() => {
    if (window.innerWidth < 992 && isOpen) {
      toggleSidebar();
    }
  }, [location.pathname]);

  const toggleMenu = (label) => {
    setOpenMenus(prev => ({ ...prev, [label]: !prev[label] }));
  };

  const menuStructure = [
    { path: "/admin/", label: "الرئيسية", icon: "bi-house-door-fill" },
    {
      label: "الفعاليات والنشاطات",
      icon: "bi-building-fill",
      subItems: [
        { path: "/admin/establishments", label: "إدارة الفعاليات" },
        { path: "/admin/visits-report", label: "تقرير الزيارات" },
        { path: "/admin/violation-report", label: "تقرير الضبوط" },



        { path: "/admin/generate-uid", label: "توليد QR" },

      ],
    },
    {
      label: "إدارة المستخدمين",
      icon: "bi-people-fill",
      adminOnly: true,
      subItems: [
        { path: "/admin/users-management", label: "قائمة المستخدمين" },
        { path: "/admin/roles-management", label: "إدارة الأدوار" },
        { path: "/admin/permissions-management", label: "الصلاحيات" },

        { path: "/admin/activities-management", label: "النشاطات" },
        { path: "/admin/facilitytypes-management", label: "نوع الفعالية" },
      ],
    },
    {
      label: "المواد والأسعار",
      icon: "bi-tag-fill",
      subItems: [
        { path: "/admin/price-survey-categories", label: "أنواع المواد" },
        { path: "/admin/price-survey-products", label: "المواد والمنتجات" },
        { path: "/admin/usd-exchange-rate", label: "سعر صرف الدولار" },
      ],
    },
    {
      label: "الدوريات والمهام",
      icon: "bi-shield-shaded",
      subItems: [
        { path: "/admin/patrol-rosters", label: "إدارة الدوريات" },
        // { path: "/admin/inspection-mission/create", label: "إسناد المهام" },
        { path: "/admin/i", label: "قائمة المهام" },

        { path: "/admin/violation-types-management", label: "أنواع الضبوط" },
        { path: "/admin/patrolstaff-management", label: "إدارة الموظفين" },
        { path: "/admin/location_management", label: "إدارة المواقع" },



      ],
    },
  ];

  return (
    <>
      {/* --- الغشاء المضبب (Mobile Overlay) --- */}
      {isOpen && (
        <div
          className="mobile-overlay d-lg-none"
          onClick={toggleSidebar}
        ></div>
      )}

      <div
        className="sidebar-container shadow-lg d-flex flex-column bg-dark"
        style={{
          width: "260px",
          right: isOpen ? "0" : "-260px",
          transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.1), top 0.3s ease",
          zIndex: 1200, // رفعنا الـ z-index ليكون فوق الغشاء
          direction: "rtl",
          borderLeft: "1px solid rgba(255,255,255,0.05)",
          position: "fixed",
          top: isScrolled ? "0" : "70px",
          height: isScrolled ? "100vh" : "calc(100vh - 56px)",
          bottom: 0,
        }}
      >
        {/* هيدر القائمة */}
        <div className="p-4 d-flex align-items-center justify-content-between border-bottom border-secondary border-opacity-10">
          <div className="d-flex align-items-center gap-2">
            <img src="/website-icon.png" alt="Logo" style={{ width: "30px", height: "auto" }} />
            <span className="text-white fw-bold m-0" style={{ fontSize: '1rem' }}>حماية المستهلك</span>
          </div>
          <button onClick={toggleSidebar} className="btn btn-sm btn-outline-secondary border-0 text-white p-0" style={{ width: '35px', height: '35px' }}>
            <i className="bi bi-chevron-double-right fs-5"></i>
          </button>
        </div>

        {/* محتوى الروابط */}
        <div className="flex-grow-1 py-3" style={{ overflowY: "auto" }}>
          <ul className="nav flex-column px-2 gap-1">
            {menuStructure.filter(item => !item.adminOnly || isAdmin).map((item, index) => {
              const hasSub = !!item.subItems;
              const isParentActive = hasSub && item.subItems.some(sub => location.pathname === sub.path);
              const isActive = location.pathname === item.path;
              const isMenuOpen = openMenus[item.label] || isParentActive;

              return (
                <li key={index} className="nav-item">
                  {hasSub ? (
                    <>
                      <div
                        onClick={() => toggleMenu(item.label)}
                        className={`nav-link d-flex align-items-center py-2 px-3 rounded-3 transition-all
                          ${isParentActive ? "active-parent text-info" : "text-white-50 hover-bg"}`}
                        style={{ cursor: "pointer", fontSize: "0.92rem" }}
                      >
                        <i className={`bi ${item.icon} ms-3 fs-5 ${isParentActive ? 'text-info' : ''}`}></i>
                        <span className="flex-grow-1 fw-medium">{item.label}</span>
                        <i className={`bi bi-chevron-${isMenuOpen ? 'down' : 'left'} small transition-all`}></i>
                      </div>

                      <div className={`submenu-wrapper ${isMenuOpen ? 'show' : ''}`}>
                        <ul className="nav flex-column mt-1 bg-dark bg-opacity-25 rounded-3">
                          {item.subItems.map((sub, sIdx) => {
                            const isSubActive = location.pathname === sub.path;
                            return (
                              <li key={sIdx}>
                                <Link
                                  to={sub.path}
                                  className={`nav-link py-2 px-2 small transition-all rounded-3 mb-1
                                    ${isSubActive ? "text-info active-sub-link" : "text-white-50 hover-text-white"}`}
                                  style={{ paddingRight: '3.2rem' }}
                                >
                                  {sub.label}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <Link
                      to={item.path}
                      className={`nav-link d-flex align-items-center py-2 px-3 rounded-3 transition-all
                        ${isActive ? "bg-info bg-opacity-10 text-info active-link" : "text-white-50 hover-bg"}`}
                      style={{ fontSize: "0.92rem" }}
                    >
                      <i className={`bi ${item.icon} ms-3 fs-5`}></i>
                      <span className="fw-medium">{item.label}</span>
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <style>{`
          /* الغشاء الخلفي للموبايل */
          .mobile-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0, 0, 0, 0.4);
            backdrop-filter: blur(4px); /* هذا هو سر التغبيش */
            -webkit-backdrop-filter: blur(4px);
            z-index: 1150;
            animation: fadeIn 0.3s ease;
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          .submenu-wrapper { max-height: 0; overflow: hidden; transition: all 0.4s ease-in-out; opacity: 0; }
          .submenu-wrapper.show { max-height: 500px; opacity: 1; }
          .hover-bg:hover { background-color: rgba(255, 255, 255, 0.05); color: #fff !important; transform: translateX(-3px); }
          .hover-text-white:hover { color: #0dcaf0 !important; padding-right: 1.5rem !important; }
          .active-parent { background-color: rgba(13, 240, 164, 0.05); }
          .active-sub-link { background-color: rgba(13, 202, 240, 0.12); font-weight: bold; position: relative; }
          .active-sub-link::before { content: ""; position: absolute; right: -15px; top: 55%; transform: translateY(-50%); width: 4px; height: 4px; background-color: #0dcaf0; border-radius: 50%; box-shadow: 0 0 8px #0dcaf0; }
          .active-link { box-shadow: inset -4px 0 0 #0dcaf0; }
          .transition-all { transition: all 0.3s ease; }
          div::-webkit-scrollbar { width: 5px; }
          div::-webkit-scrollbar-thumb { background: #333; border-radius: 10px; }
          
          /* تعديلات الموبايل */
          @media (max-width: 991.98px) {
            .sidebar-container {
              top: 0 !important; /* في الموبايل تبدأ دائماً من الأعلى */
              height: 100vh !important;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default Sidebar;